<template>
  <div class="container">

        <!-- Outer Row -->
        <div class="row justify-content-center">

            <div class="col-xl-10 col-lg-12 col-md-9">

                <div class="card o-hidden border-0 shadow-lg my-5">
                    <div class="card-body p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="row">
                            <div class="col-lg-6 d-none d-lg-block bg-password-image" style="background-image: url(park.jpg);"></div>
                            <div class="col-lg-6">
                                <div class="p-5">
                                    <div class="text-center">
                                        <h1 class="h4 text-gray-900 mb-2">ลืมรหัสผ่านใช่หรือไม่ ?</h1>
                                        <p class="mb-4">กรอกอีเมล์ของคุณลงในกล่องอีเมล์ แล้วกดปุ่มขอรหัสผ่านใหม่ ระบบจะส่งรหัสผ่านใหม่ไปให้คุณผ่านอีเมล์ที่ระบุ</p>
                                    </div>
                                    <form class="user" @submit.prevent="resetPassword">
                                        <div class="form-group">
                                            <input required type="email" v-model="email" class="form-control form-control-user"
                                                id="exampleInputEmail" aria-describedby="emailHelp"
                                                placeholder="กรอกอีเมล์ที่นี่...">
                                        </div>
                                        <button id="btnResetPassWord" type="submit" class="btn btn-primary btn-user btn-block">
                                            ขอรหัสผ่านใหม่
                                        </button>
                                    </form>
                                    <hr>
                                    <div class="text-center">
                                        <router-link class="small" to="login">กลับไปที่หน้าเข้าสู่ระบบ !</router-link>
                                    </div>
                                    <div style="height: 100px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

    
</template>


<script>
import { AuthService } from '@/services/auth.service'
import { AlertService } from '@/services/alert.service'

export default {
    data() {
        return {
            email: ""
        }
    },
    methods: {
        async resetPassword(){
            if(AlertService.confirm(window.$("#btnResetPassWord"),"ยืนยันทำรายการ?")){
                AlertService.loading(true,"รีเซ็ตรหัสผ่าน");
                const respons = await AuthService.makeResetPass(this.email)
                if(respons.status == 200)
                {
                    AlertService.successRedirect(respons.message,"/login");
                }else
                {
                    AlertService.error(respons.message);
                }
                AlertService.loading(false);
            }
            return false;
        }
    }
}
</script>

<style>
  
</style>
